import BankDetails from "./bankDetails"
export default BankDetails